import React from 'react'
import { connect } from 'react-redux'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import {
  BsrsGrid,
  EnumFilterCell,
  EnumCellStatus,
  commandColumnProps,
  DateTimeFilterCell,
  DateTimeCell
} from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import { CreateTicketButton } from '@/internal-app/pages/tickets/createTicketButton'
import NameColumn from '@/components/BsrsGrid/BsrsGrid.NameColumn'

@localized()
class MyTickets extends React.Component {
  render () {
    const { localize, locale } = this.props
    const enumName = 'TicketStatus'
    const resultEnumName = 'TicketResult'
    return (
      <React.Fragment>
        <Main>
          <MainTop>
            <MainTopTitle>
              <Resx name='Tickets.TicketsTitle' />
            </MainTopTitle>
            <MainTopLeft>
              <CreateTicketButton className='btn btn-sm btn-primary' />
            </MainTopLeft>
          </MainTop>
          <MainBody>
            <BsrsGrid
              persistenceId={'tickets'}
              dataSource={context.api.ticketService.getTableData}
              lastReloadedAt={this.props.myTickets.gridKey}
              defaultSort={[{ field: 'id', dir: 'desc' }]}>
              <Column field='id' title={localize('Common.Id')} filter='numeric' editable={false} />
              <Column field='ticketType' title={localize('Common.Type')} editable={false} />
              {NameColumn({ locale, title: localize('Common.Name'), editable: false })}
              <Column field='author' title={localize('Common.Author')} editable={false} />
              <Column field='creationTime' title={localize('Common.CreationTime')} cell={DateTimeCell} filterCell={DateTimeFilterCell} editable={false} />
              <Column field='status' title={localize('Common.Status')} editable={false} width='120px'
                cell={EnumCellStatus({ localize, enumName, visualStatus: [0, 1, 2, 3, 3] })}
                filterCell={EnumFilterCell({ localize, enumName }, [0, 1, 2, 3, 4])} enumName={enumName} />
              <Column field='result'title={localize('Common.Result')} editable={false} width='120px'
                cell={EnumCellStatus({ localize, enumName: resultEnumName, visualStatus: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14] })}
                filterCell={EnumFilterCell({ localize, enumName: resultEnumName }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14])} enumName={resultEnumName} />
              <Column {...commandColumnProps({ detailUrl: x => x.canSeeDetail ? `/tickets/${x.id}` : '' })} />
            </BsrsGrid>
          </MainBody>
        </Main>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    myTickets: state.myTickets
  }
}

export default connect(mapStateToProps)(MyTickets)



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/list.js